/* Beleaev — Layout: move inner <quantity-input> into product-form__buttons
   so it sits beside ADD TO CART. Buy with Shop stays below.
   Also: wrap "From " prefix in card prices for Petrossian-style typography. */
(function() {
  'use strict';

  function restructure() {
    document.querySelectorAll('product-info, [id^="ProductInfo-"]').forEach(function(root) {
      if (!root.isConnected) return;
      const primaryBtn = root.querySelector('.product-form__submit.button--primary');
      const quantity = root.querySelector('.product-form__quantity-top quantity-input');
      const buttons = primaryBtn && primaryBtn.closest('.product-form__buttons');
      const form = primaryBtn && primaryBtn.closest('form');
      const input = quantity && quantity.querySelector('input[name="quantity"]');
      if (!buttons || !quantity || !input || !form || input.getAttribute('form') !== form.getAttribute('id')) return;
      if (quantity.contains(buttons)) return;
      if (quantity.parentElement !== buttons) buttons.insertBefore(quantity, primaryBtn);
      buttons.classList.add('beleaev-buttons-row');
    });
  }

  /* Add curator badges (Top Seller / Sommelier's Choice / Beginner's Pick /
     Best Value) to the four caviar grades. Pill in top-left corner of media.
     Specific (full-handle) matchers come FIRST so they win over generic regex. */
  const BELEAEV_BADGES = [
    /* --- Signature Tasting Set: three thematic labels by grammage (10.07.2026).
       Handle-specific (4x125g / 4x50g) FIRST so they win over the generic
       signature-tasting-set matcher (which then catches the base 4x30g). --- */
    {
      match: /signature-tasting-set-4x125g/i,
      label: "Connoisseur's Choice",
      tone: 'gold',
      icon: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.6l1.7 4.1 4.4.3-3.4 2.9 1.1 4.3L12 12.9l-3.8 1.3 1.1-4.3-3.4-2.9 4.4-.3L12 2.6z" fill="currentColor"/><path d="M4.2 12c0 4.1 3.1 7.2 8 8.3-4-3.1-5-5.2-5-8.1 0-1 .2-2 .2-2C5.4 11 4.2 12 4.2 12z" fill="currentColor" opacity=".55"/><path d="M19.8 12c0 4.1-3.1 7.2-8 8.3 4-3.1 5-5.2 5-8.1 0-1-.2-2-.2-2C18.6 11 19.8 12 19.8 12z" fill="currentColor" opacity=".55"/></svg>'
    },
    {
      match: /signature-tasting-set-4x50g/i,
      label: 'Grand Tasting',
      tone: 'gold',
      icon: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 1.5l2.7 6.6 7.1.6-5.4 4.7 1.7 6.9L12 16.6l-6.1 3.7 1.7-6.9-5.4-4.7 7.1-.6L12 1.5z" fill="currentColor"/></svg>'
    },
    {
      match: /signature-tasting-set/i,
      label: 'Tasting Flight',
      tone: 'gold',
      icon: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="4" cy="12" r="2.4" fill="currentColor"/><circle cx="9.3" cy="12" r="2.4" fill="currentColor"/><circle cx="14.7" cy="12" r="2.4" fill="currentColor"/><circle cx="20" cy="12" r="2.4" fill="currentColor"/></svg>'
    },
    /* --- Specific matchers for Beleaev's 3 newest grades (28.04.2026) --- */
    {
      match: /almaz-diamond|almaz/i,
      label: 'Diamond Tier',
      tone: 'gold',
      icon: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2L22 10 12 22 2 10z" fill="currentColor"/></svg>'
    },
    {
      match: /beluga-xxl|xxl-special-reserve|beluga[\s-]xxl/i,
      label: 'XXL Grand Cru',
      tone: 'gold',
      icon: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 1.5l2.7 6.6 7.1.6-5.4 4.7 1.7 6.9L12 16.6l-6.1 3.7 1.7-6.9-5.4-4.7 7.1-.6L12 1.5z" fill="currentColor"/></svg>'
    },
    {
      match: /golden-oscietra|gold[\s-]oscietra|oscietra[\s-]special/i,
      label: 'Gold Prestige',
      tone: 'gold',
      icon: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 8l4 4 5-7 5 7 4-4-2 11H5L3 8z" fill="currentColor"/></svg>'
    },
    /* --- Generic matchers for the four classic grades --- */
    {
      match: /imperial/i,
      label: 'Top Seller',
      tone: 'gold',
      icon: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 8l4 4 5-7 5 7 4-4-2 11H5L3 8zm2 13h14v1.5H5V21z" fill="currentColor"/></svg>'
    },
    {
      match: /beluga/i,
      label: "Sommelier's Choice",
      tone: 'cream',
      icon: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.5l2.7 6.6 7.1.6-5.4 4.7 1.7 6.9L12 17.6l-6.1 3.7 1.7-6.9-5.4-4.7 7.1-.6L12 2.5z" fill="currentColor"/></svg>'
    },
    {
      match: /baerii?\b/i,
      label: "Beginner's Pick",
      tone: 'cream',
      icon: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 22s-1-3-1-7c0-5 4-8 9-8 0 4-2 8-5 10-1.5 1-3 5-3 5zm-3-4c-3-1-5-4-5-8 4 0 7 2 8 5-1 1-2 2-3 3z" fill="currentColor"/></svg>'
    },
    {
      match: /oscietra|ossetra/i,
      label: 'Best Value',
      tone: 'gold',
      icon: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 3h12l4 6-10 12L2 9l4-6zm0 6h12l-3-4H9L6 9zm5 1l-3 0 4 8 4-8h-3l-1 2-1-2z" fill="currentColor"/></svg>'
    },
    {
      match: /wild[\s-]salmon|salmon[\s-]roe/i,
      label: 'Family Choice',
      tone: 'gold',
      icon: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 11a2.8 2.8 0 100-5.6 2.8 2.8 0 000 5.6zm6 0a2.8 2.8 0 100-5.6 2.8 2.8 0 000 5.6zm-6 1.4c-2.8 0-5.6 1.4-5.6 3.7V18h11.2v-1.9c0-2.3-2.8-3.7-5.6-3.7zm6 0c-.6 0-1.4.1-2.1.3 1.3 1 2.1 2.1 2.1 3.4V18H21v-1.9c0-2.3-2.8-3.7-6-3.7z" fill="currentColor"/></svg>'
    }
  ];

  /* Localised labels for the dark caviar badges (10.07.2026). English is the
     default/fallback; ES uses usted-neutral nouns, DE uses Sie-neutral nouns. */
  var BELEAEV_BADGE_I18N = {
    es: {
      "Tasting Flight": "Degustación", "Grand Tasting": "Gran Degustación", "Connoisseur's Choice": "Selección Experta",
      "Best Value": "Mejor Valor", "Beginner's Pick": "Para Iniciarse", "Top Seller": "Más Vendido",
      "Sommelier's Choice": "Selección Sommelier", "Diamond Tier": "Nivel Diamante", "XXL Grand Cru": "Grand Cru XXL",
      "Gold Prestige": "Prestigio Oro", "Family Choice": "Para la Familia"
    },
    de: {
      "Tasting Flight": "Verkostung", "Grand Tasting": "Große Verkostung", "Connoisseur's Choice": "Für Kenner",
      "Best Value": "Top Preis-Leistung", "Beginner's Pick": "Für Einsteiger", "Top Seller": "Bestseller",
      "Sommelier's Choice": "Sommelier-Wahl", "Diamond Tier": "Diamant-Klasse", "XXL Grand Cru": "XXL Grand Cru",
      "Gold Prestige": "Gold-Prestige", "Family Choice": "Familienfavorit"
    }
  };
  function beleaevBadgeLabel(en) {
    var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var map = BELEAEV_BADGE_I18N[lang];
    return (map && map[en]) ? map[en] : en;
  }

  function getProductHandle(card) {
    const a = card.querySelector('a[href*="/products/"]');
    if (!a) return '';
    const m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function getCardTitle(card) {
    const h = card.querySelector('.card__heading a, .card__heading, h3 a, h3');
    return h ? (h.textContent || '').trim() : '';
  }

  /* Keep a mobile gallery plaque below the sticky header while its image is visible. */
  let galleryBadgeFrame = 0;
  function positionGalleryCuratorBadges() {
    galleryBadgeFrame = 0;
    const mobile = window.matchMedia('(max-width: 749px)').matches;
    let headerBottom = 0;
    if (mobile) {
      document.querySelectorAll('.section-header, .announcement-bar-section').forEach((header) => {
        const rect = header.getBoundingClientRect();
        if (rect.top <= 100 && rect.bottom > 0) headerBottom = Math.max(headerBottom, rect.bottom);
      });
    }
    document.querySelectorAll('.beleaev-pdp-badge-host').forEach((host) => {
      const badge = host.querySelector('.beleaev-pdp-curator-badge');
      const imageList = host.querySelector('.product__media-list');
      if (!badge || !imageList) return;
      if (!mobile) { badge.style.removeProperty('--beleaev-curator-offset'); return; }
      const hostRect = host.getBoundingClientRect();
      const imageRect = imageList.getBoundingClientRect();
      const maxTop = Math.max(20, imageRect.bottom - hostRect.top - badge.offsetHeight - 12);
      const top = Math.min(maxTop, Math.max(20, headerBottom + 12 - hostRect.top));
      badge.style.setProperty('--beleaev-curator-offset', top + 'px');
    });
  }
  function scheduleGalleryBadgePosition() {
    if (!galleryBadgeFrame) galleryBadgeFrame = requestAnimationFrame(positionGalleryCuratorBadges);
  }
  window.addEventListener('scroll', scheduleGalleryBadgePosition, { passive: true });
  window.addEventListener('resize', scheduleGalleryBadgePosition, { passive: true });
  window.addEventListener('load', scheduleGalleryBadgePosition, { once: true });

  /* Reuse collection curator labels and icons on the product's main gallery. */
  function addGalleryCuratorBadges() {
    document.querySelectorAll('media-gallery[data-beleaev-curator-product]').forEach((gallery) => {
      const host = gallery.querySelector('slider-component[id^="GalleryViewer-"]');
      if (!host || host.querySelector('.beleaev-pdp-curator-badge')) return;
      const haystack = gallery.dataset.beleaevCuratorProduct + ' ' + gallery.dataset.beleaevCuratorTitle;
      const match = BELEAEV_BADGES.find((entry) => entry.match.test(haystack));
      if (!match) return;
      const badge = document.createElement('span');
      badge.className = 'beleaev-badge beleaev-badge--' + match.tone + ' beleaev-pdp-curator-badge';
      const icon = document.createElement('span');
      icon.className = 'beleaev-badge__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML = match.icon;
      const label = document.createElement('span');
      label.className = 'beleaev-badge__text';
      label.textContent = beleaevBadgeLabel(match.label);
      badge.append(icon, label);
      host.classList.add('beleaev-pdp-badge-host');
      host.appendChild(badge);
      scheduleGalleryBadgePosition();
    });
  }

  function addProductBadges() {
    addGalleryCuratorBadges();
    const cards = document.querySelectorAll('.card-wrapper, .grid__item');
    cards.forEach((card) => {
      if (card.querySelector('.beleaev-badge')) return;
      /* Skip FAQ accordion and other non-product grid items */
      if (card.querySelector('details, summary, .accordion')) return;
      const haystack = (getProductHandle(card) + ' ' + getCardTitle(card)).toLowerCase();
      const match = BELEAEV_BADGES.find((b) => b.match.test(haystack));
      if (!match) return;
      // Append to card-wrapper / card — NOT to .card__media (which has overflow:hidden
      // and clips the absolute-positioned badge when card is narrow).
      const host = card.querySelector('.card__inner') || (card.classList.contains('card-wrapper') ? card : (card.querySelector('.card-wrapper') || card.querySelector('.card') || card));
      if (!host) return;
      if (getComputedStyle(host).position === 'static') {
        host.style.position = 'relative';
      }
      const badge = document.createElement('span');
      badge.className = 'beleaev-badge beleaev-badge--' + match.tone;
      badge.setAttribute('aria-label', match.label);
      badge.innerHTML =
        '<span class="beleaev-badge__icon">' + match.icon + '</span>' +
        '<span class="beleaev-badge__text">' + beleaevBadgeLabel(match.label) + '</span>';
      host.appendChild(badge);
    });
  }

  /* Move .quick-add (bag icon) inline beside .price by wrapping both in
     .beleaev-price-row flex container. Saves vertical space on mobile. */
  function inlineBagWithPrice() {
    const cards = document.querySelectorAll('.card-wrapper, .grid__item');
    cards.forEach((card) => {
      if (card.querySelector('details, summary, .accordion')) return;
      const price = card.querySelector('.price');
      const quickAdd = card.querySelector('.quick-add');
      if (!price || !quickAdd) return;
      if (price.parentElement && price.parentElement.classList.contains('beleaev-price-row')) return;
      const wrap = document.createElement('div');
      wrap.className = 'beleaev-price-row';
      price.parentNode.insertBefore(wrap, price);
      wrap.appendChild(price);
      wrap.appendChild(quickAdd);
    });
  }

  /* Wrap "From " prefix in <span class="price__from"> so it can be styled
     smaller than the actual price (Petrossian-style cards). */
  function wrapFromPrefix() {
    const items = document.querySelectorAll(
      '.card-wrapper .price__regular .price-item--regular, ' +
      '.card .price__regular .price-item--regular, ' +
      '.grid__item .price__regular .price-item--regular'
    );
    items.forEach((el) => {
      if (el.dataset.beleaevFrom === '1') return;
      const txt = (el.textContent || '').trim();
      const m = txt.match(/^From\s+(.+)$/i);
      if (!m) {
        // No "From" — still mark price__amount for consistent styling
        if (txt) {
          el.innerHTML = '<span class="price__amount">' +
            txt.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</span>';
          el.dataset.beleaevFrom = '1';
        }
        return;
      }
      el.innerHTML =
        '<span class="price__from">From</span><span class="price__amount">' +
        m[1].replace(/&/g, '&amp;').replace(/</g, '&lt;') +
        '</span>';
      el.dataset.beleaevFrom = '1';
    });
  }

  function wrapCardCurrencyCodes() {
    document.querySelectorAll('.card-wrapper .price-item, .card-wrapper .price__amount').forEach((amount) => {
      const walker = document.createTreeWalker(amount, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (!node.parentElement.closest('.beleaev-card-currency') && /\s+GBP\s*$/.test(node.textContent)) nodes.push(node);
      }
      nodes.forEach((node) => {
        const match = node.textContent.match(/\s+GBP\s*$/);
        const code = document.createElement('span');
        code.className = 'beleaev-card-currency';
        code.textContent = match[0];
        node.textContent = node.textContent.slice(0, -match[0].length);
        node.parentNode.insertBefore(code, node.nextSibling);
      });
    });
  }

  /* Lift the From label on mobile. Center label and price at full card width,
     then place the bag below to prevent overlaps on narrow product cards.
     Desktop layout is owned by CSS after inline styles are cleared. */
  function liftFromLabelMobile() {
    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    document.querySelectorAll('.product-card-wrapper').forEach((wrap) => {
      const row = wrap.querySelector('.beleaev-price-row');
      if (!row) return;
      const octVisual = row.querySelector(':scope > .beleaev-oct-card-price');
      if (octVisual) {
        const octQuickAdd = row.querySelector(':scope > .quick-add');
        const octNativePrice = row.querySelector(':scope > .price');
        if (octQuickAdd) row.insertBefore(octVisual, octQuickAdd);
        if (octNativePrice) octNativePrice.style.setProperty('display', 'none', 'important');
        const liftedLabel = row.querySelector(':scope > .beleaev-from-label-mobile');
        row.style.setProperty('display', 'flex', 'important');
        ['grid-template-columns', 'grid-template-areas', 'column-gap', 'row-gap'].forEach((property) => row.style.removeProperty(property));
        row.style.setProperty('align-items', 'center', 'important');
        row.style.setProperty('justify-content', 'space-between', 'important');
        row.style.setProperty('gap', '0.6rem', 'important');
        if (liftedLabel) liftedLabel.style.setProperty('display', 'none', 'important');
        octVisual.style.setProperty('flex', '1 1 auto', 'important');
        octVisual.style.setProperty('min-width', '0', 'important');
        if (octQuickAdd) {
          ['grid-area', 'align-self', 'position', 'inset'].forEach((property) => octQuickAdd.style.removeProperty(property));
          octQuickAdd.style.setProperty('position', 'relative', 'important');
          octQuickAdd.style.setProperty('inset', 'auto', 'important');
          octQuickAdd.style.setProperty('flex', '0 0 auto', 'important');
        }
        return;
      }
      const from = row.querySelector('.price__from');
      // Cleanup legacy labels left as siblings outside the row
      wrap.querySelectorAll('.beleaev-from-label-mobile').forEach((el) => {
        if (el.parentElement !== row) el.remove();
      });
      // Insert lifted label if "From" prefix exists and not already inserted
      if (from && !row.querySelector(':scope > .beleaev-from-label-mobile')) {
        const label = document.createElement('span');
        label.className = 'beleaev-from-label-mobile';
        label.textContent = 'From';
        const priceEl = row.querySelector('.price');
        if (priceEl) {
          row.insertBefore(label, priceEl);
        } else {
          row.appendChild(label);
        }
      }
      // Apply inline grid layout on mobile (beats any cascade conflict)
      const qa = row.querySelector('.quick-add');
      const label = row.querySelector(':scope > .beleaev-from-label-mobile');
      const priceEl = row.querySelector('.price');
      const inlineFrom = row.querySelector('.price__from');
      if (isMobile) {
        row.style.setProperty('display', 'grid', 'important');
        row.style.setProperty('grid-template-columns', '32px minmax(0, 1fr) 32px', 'important');
        // Single row: small "From" sits inline before the amount, keeping the price close to the reviews
        row.style.setProperty('grid-template-areas', '". price icon"', 'important');
        row.style.setProperty('column-gap', '0.7rem', 'important');
        row.style.setProperty('row-gap', '0', 'important');
        row.style.setProperty('align-items', 'center', 'important');
        if (qa) {
          qa.style.setProperty('grid-area', 'icon', 'important');
          qa.style.setProperty('align-self', 'center', 'important');
          qa.style.setProperty('position', 'relative', 'important');
          qa.style.setProperty('inset', 'auto', 'important');
        }
        if (label) label.style.setProperty('display', 'none', 'important');
        if (priceEl) {
          priceEl.style.setProperty('grid-area', 'price', 'important');
          priceEl.style.setProperty('text-align', 'left', 'important');
          priceEl.style.setProperty('align-self', 'center', 'important');
          priceEl.style.setProperty('margin', '0', 'important');
        }
        if (inlineFrom) {
          inlineFrom.style.setProperty('display', 'inline', 'important');
          inlineFrom.style.setProperty('font-size', '10px', 'important');
          inlineFrom.style.setProperty('font-weight', '400', 'important');
          inlineFrom.style.setProperty('margin-right', '4px', 'important');
        }
      } else {
        // Desktop: remove inline styles so the stylesheet owns the layout
        ['display','grid-template-columns','grid-template-areas','column-gap','row-gap','align-items'].forEach(p => row.style.removeProperty(p));
        if (qa) ['grid-area','align-self','position','inset'].forEach(p => qa.style.removeProperty(p));
        if (label) ['display','grid-area','text-align','align-self'].forEach(p => label.style.removeProperty(p));
        if (priceEl) ['grid-area','text-align','align-self','margin'].forEach(p => priceEl.style.removeProperty(p));
        if (inlineFrom) ['display','font-size','font-weight','margin-right'].forEach(p => inlineFrom.style.removeProperty(p));
      }
    });
  }
  // Re-run on viewport resize crossing 749px boundary
  if (window.matchMedia) {
    window.matchMedia('(max-width: 749px)').addEventListener('change', liftFromLabelMobile);
  }

  /* Add UK flag emblem to "British Quality Control" heading */
  const UK_FLAG_SVG =
    '<svg viewBox="0 0 60 30" aria-hidden="true">' +
    '<clipPath id="bqc-clip"><path d="M0,0v30h60V0z"/></clipPath>' +
    '<clipPath id="bqc-clip2"><path d="M30,15h30v15zv15h-30zh-30v-15zv-15h30z"/></clipPath>' +
    '<g clip-path="url(#bqc-clip)">' +
    '<path d="M0,0v30h60V0z" fill="#012169"/>' +
    '<path d="M0,0L60,30M60,0L0,30" stroke="#fff" stroke-width="6"/>' +
    '<path d="M0,0L60,30M60,0L0,30" clip-path="url(#bqc-clip2)" stroke="#C8102E" stroke-width="4"/>' +
    '<path d="M30,0v30M0,15h60" stroke="#fff" stroke-width="10"/>' +
    '<path d="M30,0v30M0,15h60" stroke="#C8102E" stroke-width="6"/>' +
    '</g></svg>';

  function decorateBritishQualityControl() {
    const headings = document.querySelectorAll(
      '.image-with-text__heading, h1, h2'
    );
    headings.forEach((h) => {
      if (h.dataset.beleaevBqc === '1') return;
      const txt = (h.textContent || '').trim();
      if (!/british\s+quality\s+control/i.test(txt)) return;
      const flag = document.createElement('span');
      flag.className = 'beleaev-uk-flag';
      flag.setAttribute('aria-label', 'UK quality control');
      flag.innerHTML = UK_FLAG_SVG;
      h.insertBefore(flag, h.firstChild);
      h.classList.add('beleaev-bqc-heading');
      const sec = h.closest('section, .shopify-section, [class*="section-template"]');
      if (sec) sec.classList.add('beleaev-bqc-section');
      h.dataset.beleaevBqc = '1';
    });
  }

  /* SEO + visible H1 on homepage: styled brand subtitle bar between header and hero. */
  function ensureHomepageH1() {
    const isHome =
      document.body.classList.contains('template-index') ||
      location.pathname === '/' ||
      location.pathname === '';
    if (!isHome) return;
    const existing = Array.from(document.querySelectorAll('h1')).find(
      (h) => (h.textContent || '').trim() && !h.classList.contains('beleaev-h1')
    );
    if (existing) return;
    if (document.querySelector('h1.beleaev-h1')) return;
    const h1 = document.createElement('h1');
    h1.className = 'beleaev-h1';
    /* Rotating phrases: fade in/hold/fade out, one at a time (Petrossian-style).
       Each item gets a CSS animation-delay equal to slot index × per-slot duration. */
    const phrases = [
      'The Finest Caviar, Hand-Delivered in 24h Across the UK, EU & the UAE',
      'Free delivery on orders over 200£',
      'Secure card payment'
    ];
    const PHRASE_DURATION = 4; /* seconds visible per phrase (incl. fade) */
    const items = phrases.map(function(p, i) {
      return '<span class="beleaev-h1__item" style="animation-delay:' + (i * PHRASE_DURATION) + 's">' + p + '</span>';
    }).join('');
    h1.innerHTML = '<span class="beleaev-h1__track" style="--bb-cycle:' + (phrases.length * PHRASE_DURATION) + 's">' + items + '</span>';
    /* Insert INSIDE the theme's <sticky-header> element as the first child.
       This way the theme's own sticky behaviour drags the marquee with the logo + menu,
       no conflict with absolutely-positioned logo, no body padding hack needed. */
    const stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader) {
      stickyHeader.insertBefore(h1, stickyHeader.firstChild);
    } else {
      document.body.insertBefore(h1, document.body.firstChild);
    }
    document.body.classList.add('beleaev-has-h1');
  }

  /* Cart drawer footer: compact payment icons row.
     Visa / MC / Amex / PayPal / Apple Pay / Google Pay / Klarna / Shop Pay */
  const PAYMENT_ICONS = {
    visa:    '<svg viewBox="0 0 38 24" aria-hidden="true" focusable="false"><rect width="38" height="24" rx="3" fill="#1A1F71"/><path d="M15.6 16.8l1.7-9.6h2.7l-1.7 9.6h-2.7zm12.7-9.4c-.5-.2-1.4-.4-2.4-.4-2.7 0-4.6 1.4-4.6 3.4 0 1.5 1.4 2.3 2.4 2.8 1 .5 1.4.8 1.4 1.3 0 .7-.9 1-1.7 1-1.1 0-1.7-.2-2.6-.6l-.4-.2-.4 2.4c.7.3 2 .6 3.3.6 2.9 0 4.7-1.4 4.7-3.5 0-1.2-.7-2-2.3-2.7-1-.5-1.6-.8-1.6-1.3 0-.5.5-1 1.6-1 .9 0 1.6.2 2.1.4l.3.1.4-2.3zm6.9-.2h-2c-.6 0-1.1.2-1.4.8L26.7 16.8h2.9s.5-1.3.6-1.6h3.5c.1.4.3 1.6.3 1.6h2.6l-2.3-9.4zm-3.5 6.2c.2-.6 1.1-3 1.1-3l.3-.8.1.7s.5 2.6.6 3.1h-2.1zM13.3 7.2L10.7 13.7l-.3-1.4c-.5-1.6-2-3.4-3.7-4.3l2.4 8.8h2.9l4.4-9.6h-3.1z" fill="#fff"/></svg>',
    mc:      '<svg viewBox="0 0 38 24" aria-hidden="true" focusable="false"><rect width="38" height="24" rx="3" fill="#fff"/><circle cx="14" cy="12" r="6.5" fill="#EB001B"/><circle cx="24" cy="12" r="6.5" fill="#F79E1B"/><path d="M19 7.2a6.5 6.5 0 010 9.6 6.5 6.5 0 010-9.6z" fill="#FF5F00"/></svg>',
    amex:    '<svg viewBox="0 0 38 24" aria-hidden="true" focusable="false"><rect width="38" height="24" rx="3" fill="#016FD0"/><path d="M19 6.5l-2.4 5.4-2.4-5.4h-3.5v8h2.1V8.6l2.4 5.9h2.6l2.4-5.9v5.9h2.1V6.5h-3.3zm6.7 8L23 6.5h2.4l2.7 8h-2.4z" fill="#fff"/></svg>',
    paypal:  '<svg viewBox="0 0 38 24" aria-hidden="true" focusable="false"><rect width="38" height="24" rx="3" fill="#fff"/><path d="M14.5 7.5c.5-.4 1.2-.6 2-.6h3.6c1 0 1.8.3 2.2 1 .4.6.5 1.5.2 2.5-.5 1.6-2 2.6-3.8 2.6h-1.4l-.6 3.5h-2L14.5 7.5z" fill="#003087"/><path d="M22.5 9.5c-.5 1.6-2 2.6-3.8 2.6h-1.4l-.6 3.5h-1.4l-.7 4.4c0 .2.1.3.3.3h1.5c.2 0 .4-.1.5-.4l.5-3.1c0-.2.2-.4.5-.4h.7c1.8 0 3.3-1 3.8-2.6.4-1.4 0-2.5-.9-3.1-.4-.3-.4-.6-.5-1.2 0-.1.1-.1 0 0z" fill="#0070E0"/></svg>',
    apple:   '<svg viewBox="0 0 38 24" aria-hidden="true" focusable="false"><rect width="38" height="24" rx="3" fill="#000"/><path d="M13 9.7c.5-.6.8-1.4.7-2.2-.7 0-1.5.4-2 1-.4.5-.8 1.4-.7 2.1.8.1 1.5-.3 2-.9zm.7.4c-1.1-.1-2 .6-2.5.6-.5 0-1.3-.6-2.2-.6-1.1 0-2.2.7-2.7 1.7-1.2 2-.3 5 .9 6.6.6.8 1.3 1.7 2.2 1.7s1.2-.6 2.2-.6 1.3.6 2.2.6 1.5-.8 2.1-1.6c.7-.9 1-1.8 1-1.8s-1.9-.7-2-2.9c0-1.8 1.5-2.7 1.6-2.7-.9-1.3-2.2-1.4-2.7-1.5zM21 7.5h2c2 0 3.4 1.4 3.4 3.4s-1.4 3.4-3.5 3.4h-1.4v3.2h-2V7.5h1.5zm.5 5.1h1.2c1.1 0 1.8-.6 1.8-1.7s-.7-1.7-1.8-1.7h-1.2v3.4z" fill="#fff"/></svg>',
    google:  '<svg viewBox="0 0 38 24" aria-hidden="true" focusable="false"><rect width="38" height="24" rx="3" fill="#fff" stroke="#e1e1e1"/><path d="M18.6 12.2c0-.3 0-.6-.1-.9h-3.4v1.7h2c-.1.5-.4.9-.8 1.2v1h1.3c.7-.7 1-1.7 1-3z" fill="#4285F4"/><path d="M15.1 15.7c1 0 1.8-.3 2.4-.9l-1.3-1c-.3.2-.7.4-1.1.4-.9 0-1.6-.6-1.8-1.4h-1.3v1c.5 1.2 1.7 1.9 3.1 1.9z" fill="#34A853"/><path d="M13.3 12.8c-.1-.2-.1-.5-.1-.8s0-.6.1-.8v-1H12c-.3.6-.5 1.2-.5 1.9s.2 1.3.5 1.9l1.3-1.1z" fill="#FBBC05"/><path d="M15.1 9.7c.5 0 1 .2 1.4.5l1.1-1c-.7-.6-1.5-1-2.5-1-1.4 0-2.6.7-3.1 1.9l1.3 1c.2-.7.9-1.4 1.8-1.4z" fill="#EA4335"/><path d="M22.4 9.3c-1.2 0-2.4.8-2.4 2.4 0 1.4.9 2.4 2.4 2.4.6 0 1-.1 1.4-.4v.4h1V9.7h-1V10c-.4-.4-.9-.7-1.4-.7zm.2 1c.7 0 1.3.6 1.3 1.4s-.6 1.4-1.3 1.4-1.4-.6-1.4-1.4.7-1.4 1.4-1.4z" fill="#5F6368"/></svg>',
    klarna:  '<svg viewBox="0 0 38 24" aria-hidden="true" focusable="false"><rect width="38" height="24" rx="3" fill="#FFB3C7"/><path d="M14 8.6c0 1.5-.7 2.9-1.9 3.8l1.7 2.4h-1.7l-1.5-2c0 0-.1 0-.1 0v2H9.1V6.9h1.4v3.7c.9-.5 1.4-1.4 1.4-2.5h1.4l.7.5zm1.9-1.7v8h1.4v-8h-1.4zm5.7 4.2c0-.9-.7-1.4-1.5-1.4-.7 0-1.3.3-1.6.9V9.7h-1.3v5.1h1.3v-2.5c0-.5.4-.9.9-.9s.9.4.9.9v2.5h1.3v-2.7zm5.4 1.7c0 1-.7 1.5-1.5 1.5-.5 0-.9-.2-1.2-.5l.6-.8c.1.2.4.3.6.3.3 0 .5-.1.5-.4 0-.5-1.6-.4-1.6-1.5 0-.7.6-1.2 1.4-1.2.5 0 .9.2 1.2.5l-.6.8c-.2-.1-.4-.3-.6-.3-.2 0-.4.1-.4.3 0 .4 1.6.3 1.6 1.3z" fill="#0a0a0a"/></svg>'
  };

  function injectPaymentIcons() {
    const drawers = document.querySelectorAll('cart-drawer, .drawer__inner, #CartDrawer, .cart-drawer');
    drawers.forEach((drawer) => {
      if (drawer.querySelector('.beleaev-pay-row')) return;
      const target =
        drawer.querySelector('.drawer__footer') ||
        drawer.querySelector('.cart-drawer__footer') ||
        drawer.querySelector('[class*="footer"]') ||
        drawer;
      if (!target) return;
      const row = document.createElement('div');
      row.className = 'beleaev-pay-row';
      row.setAttribute('aria-label', 'Accepted payment methods');
      const order = ['visa', 'mc', 'amex', 'paypal', 'apple', 'google', 'klarna'];
      row.innerHTML = order.map((k) =>
        '<span class="beleaev-pay-icon" data-pay="' + k + '">' + PAYMENT_ICONS[k] + '</span>'
      ).join('');
      target.appendChild(row);
    });

    /* Also on /cart page */
    const cartPage = document.querySelector('.cart__footer, main-cart-footer, .cart-page__footer');
    if (cartPage && !cartPage.querySelector('.beleaev-pay-row')) {
      const row = document.createElement('div');
      row.className = 'beleaev-pay-row beleaev-pay-row--page';
      row.setAttribute('aria-label', 'Accepted payment methods');
      const order = ['visa', 'mc', 'amex', 'paypal', 'apple', 'google', 'klarna'];
      row.innerHTML = order.map((k) =>
        '<span class="beleaev-pay-icon" data-pay="' + k + '">' + PAYMENT_ICONS[k] + '</span>'
      ).join('');
      cartPage.appendChild(row);
    }
  }

  /* Mobile sticky ADD-TO-CART bar at bottom of viewport on PDP.
     Mirrors the primary product form — taps it to submit. */
  function setupStickyMobileATC() {
    const isPDP = document.body.classList.contains('template-product') ||
                  document.querySelector('.product__info-container, main-product, [data-product-id]');
    if (!isPDP) return;
    if (document.getElementById('beleaev-sticky-atc')) return;
    const scope = document.querySelector('main section[id^="MainProduct-"], main product-info, main .product');
    if (!scope) return;
    const getPrimary = () => Array.from(scope.querySelectorAll('.product-form__submit'))
      .find(button => button.getClientRects().length && !button.closest('quick-add-modal, product-recommendations'));
    if (!getPrimary()) return;

    const bar = document.createElement('div');
    bar.id = 'beleaev-sticky-atc';
    bar.className = 'beleaev-sticky-atc';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Quick add to cart');
    bar.innerHTML =
      '<div class="beleaev-sticky-atc__info">' +
        '<span class="beleaev-sticky-atc__title"></span>' +
        '<span class="beleaev-sticky-atc__price"></span>' +
      '</div>' +
      '<button type="button" class="beleaev-sticky-atc__btn">' + (window.beleaevAddToCartLabel || 'Add to cart').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }) + '</button>';
    document.body.appendChild(bar);

    const btn = bar.querySelector('.beleaev-sticky-atc__btn');
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const primary = getPrimary();
      if (!primary || primary.disabled || btn.disabled) return;
      primary.click();
    });

    /* BELEAEV_INP_OPTIMIZATION_2026_08_30: avoid forced layout reads on every scroll. */
    const setPrimaryVisibility = (inView) => {
      bar.classList.toggle('beleaev-sticky-atc--show', !inView);
    };
    let watchedButton;
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
        setPrimaryVisibility(Boolean(entries[0] && entries[0].isIntersecting));
      }) : null;
    const visible = element => element && getComputedStyle(element).display !== 'none' && element.getClientRects().length;
    const priceText = () => {
      const owned = scope.querySelector('[data-blv-price-owner="allocation"] beleaev-subscription-prices:not([hidden]) [data-blv-allocation-amount]');
      if (owned) return owned.textContent.trim();
      const subscribed = scope.querySelector('.appstle_subscription_radio_wrapper input:checked');
      const subscription = Array.from(scope.querySelectorAll('.beleaev-sub-line')).find(visible);
      if (subscription?.firstElementChild) return subscription.firstElementChild.textContent.trim();
      if (subscribed) {
        const amount = scope.querySelector('.appstle_subscription_amount_wrapper .appstle_subscription_amount');
        if (amount) return amount.textContent.trim();
      }
      const custom = Array.from(scope.querySelectorAll('.beleaev-price-bottom__value, [data-beleaev-total], .beleaev-total, .beleaev-total-tasting')).find(visible);
      if (custom) return custom.textContent.trim();
      const price = scope.querySelector('.price');
      const amount = price?.classList.contains('price--on-sale')
        ? price.querySelector('.price__sale .price-item--sale, .price__sale .price-item--last')
        : price?.querySelector('.price__regular .price-item--regular');
      return amount?.textContent.trim() || '';
    };
    const syncBar = () => {
      const primary = getPrimary();
      const title = scope.querySelector('h1')?.textContent.trim() || '';
      const value = priceText().replace(/\s+/g, ' ');
      const titleNode = bar.querySelector('.beleaev-sticky-atc__title');
      const priceNode = bar.querySelector('.beleaev-sticky-atc__price');
      if (titleNode.textContent !== title) titleNode.textContent = title;
      if (priceNode.textContent !== value) priceNode.textContent = value;
      btn.disabled = !primary || primary.disabled;
      if (primary?.textContent.trim() && btn.textContent !== primary.textContent.trim()) btn.textContent = primary.textContent.trim();
      if (observer && primary !== watchedButton) {
        observer.disconnect();
        if (primary) observer.observe(primary);
        watchedButton = primary;
      }
    };
    let priceSyncPending = false;
    const schedulePriceSync = () => {
      if (priceSyncPending) return;
      priceSyncPending = true;
      requestAnimationFrame(() => { priceSyncPending = false; syncBar(); });
    };
    new MutationObserver(schedulePriceSync).observe(scope, {
      childList: true, characterData: true, subtree: true, attributes: true,
      attributeFilter: ['disabled', 'hidden', 'style', 'class', 'checked']
    });
    ['change', 'input', 'beleaev:purchase-change', 'beleaev:purchase-state-sync'].forEach(name => scope.addEventListener(name, schedulePriceSync));
    syncBar();
    if (!observer) {
      let visibilityPending = false;
      const updateVisibility = () => {
        if (visibilityPending) return;
        visibilityPending = true;
        requestAnimationFrame(() => {
          const rect = getPrimary()?.getBoundingClientRect();
          if (!rect) { visibilityPending = false; return; }
          setPrimaryVisibility(rect.top < window.innerHeight && rect.bottom > 0);
          visibilityPending = false;
        });
      };
      updateVisibility();
      window.addEventListener('scroll', updateVisibility, { passive: true });
      window.addEventListener('resize', updateVisibility);
    }
  }

  /* PDP per-serving price under main price.
     Derives servings from variant title grams (1 serving = 10g caviar). */
  function addPerServingPrice() {
    if (!document.body.classList.contains('template-product') &&
        !document.querySelector('.product__info-container, main-product')) return;
    if (document.querySelector('.beleaev-per-serving')) return;
    const priceWrap =
      document.querySelector('.product__info-container .price') ||
      document.querySelector('.product__info-container [id^="price-"]') ||
      document.querySelector('main-product .price');
    if (!priceWrap) return;
    /* Try to read first variant from window product, else parse current price + variant title */
    let grams = 0;
    let priceNumber = 0;
    const productData = window.product || (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product);
    if (productData && productData.variants && productData.variants.length) {
      const v = productData.variants[0];
      const m = String(v.title || v.option1 || '').match(/(\d+)\s*g/i);
      if (m) grams = parseInt(m[1], 10);
      priceNumber = v.price ? v.price / 100 : 0;
    }
    if (!grams || !priceNumber) {
      /* Fallback: parse rendered price + variant pill labels */
      const priceText = (priceWrap.textContent || '').match(/£\s*([\d.,]+)/);
      if (priceText) priceNumber = parseFloat(priceText[1].replace(',', ''));
      const variantLabels = Array.from(document.querySelectorAll(
        'fieldset.product-form__input--pill label, .product-form__input--pill input + label, [class*="variant"] label'
      ));
      for (const lab of variantLabels) {
        const m = (lab.textContent || '').match(/(\d+)\s*g/i);
        if (m) { grams = parseInt(m[1], 10); break; }
      }
    }
    if (!grams || !priceNumber) return;
    const servings = Math.max(1, Math.floor(grams / 10));
    const perServing = (priceNumber / servings).toFixed(2);
    const el = document.createElement('div');
    el.className = 'beleaev-per-serving';
    el.innerHTML =
      '<span class="beleaev-per-serving__amount">£' + perServing + '</span> ' +
      '<span class="beleaev-per-serving__label">per serving</span>' +
      '<span class="beleaev-per-serving__sep"> · </span><span class="beleaev-per-serving__hint" title="Approx. 10g per portion">~' + servings + ' servings</span>';
    priceWrap.parentElement.insertBefore(el, priceWrap.nextSibling);
  }

  /* Make entire product card clickable to its product page (image, badges area, etc).
     Standard Dawn pattern relies on .full-unstyled-link absolute overlay; in this theme it has zero size.
     We add an explicit click handler that avoids quick-add / explicit interactive elements. */
  function ensureCardClickable() {
    const cards = document.querySelectorAll('.card-wrapper, .grid__item');
    cards.forEach((card) => {
      if (card.dataset.beleaevClickable === '1') return;
      /* Skip FAQ accordions and other non-product grid items (Dawn uses .grid__item for many layouts) */
      if (card.querySelector('details, summary, .accordion')) return;
      const productLink = card.querySelector('a[href*="/products/"]');
      if (!productLink) return;
      const href = productLink.getAttribute('href');
      const media = card.querySelector('.card__media, .media, .card__inner') || card;
      media.style.cursor = 'pointer';
      media.addEventListener('click', (e) => {
        /* Skip if user clicked the quick-add bag, badge, button, or an existing link */
        if (e.target.closest('.quick-add, .quick-add__submit, button, a, [data-callback], summary, details')) return;
        e.preventDefault();
        window.location.href = href;
      });
      card.dataset.beleaevClickable = '1';
    });
  }

  
  function addPdpSommelierBubble() {
    if (!document.body.classList.contains('template-product')) return;
    if (document.querySelector('.beleaev-sommelier-bubble')) return;
    var phone = '447376579988';
    var msg = encodeURIComponent("Hi Anna, I'd love your guidance on choosing the right caviar for me.");
    var wa = 'https://wa.me/' + phone + '?text=' + msg;
    var btn = document.createElement('a');
    btn.className = 'beleaev-sommelier-bubble';
    btn.href = wa;
    btn.target = '_blank';
    btn.rel = 'noopener';
    btn.setAttribute('aria-label', 'Chat with Anna, our caviar sommelier on WhatsApp');
    btn.innerHTML = '<span class="beleaev-bubble-icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M20.52 3.48A11.93 11.93 0 0 0 12.04 0C5.4 0 0 5.4 0 12.04c0 2.12.55 4.18 1.6 6L0 24l6.16-1.6a12 12 0 0 0 5.88 1.49h.01c6.64 0 12.04-5.4 12.04-12.04 0-3.21-1.25-6.23-3.57-8.37zM12.04 21.7h-.01a9.87 9.87 0 0 1-5.03-1.38l-.36-.21-3.66.96.98-3.56-.23-.37a9.86 9.86 0 0 1-1.51-5.18c0-5.46 4.45-9.91 9.92-9.91 2.65 0 5.14 1.04 7.01 2.91a9.85 9.85 0 0 1 2.9 7.01c0 5.46-4.44 9.91-9.91 9.91zm5.43-7.42c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15s-.77.97-.94 1.17c-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.39-1.47-.88-.78-1.48-1.75-1.65-2.05-.17-.3-.02-.46.13-.6.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51-.17 0-.37-.02-.57-.02-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.49s1.07 2.89 1.22 3.09c.15.2 2.1 3.21 5.09 4.5.71.31 1.27.5 1.7.64.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2-1.41.25-.69.25-1.28.17-1.41-.07-.12-.27-.2-.57-.35z"/></svg>' +
      '</span>' +
      '<span class="beleaev-bubble-text">' +
        '<span class="beleaev-bubble-name">Ask Anna</span>' +
        '<span class="beleaev-bubble-sub">Caviar sommelier · WhatsApp</span>' +
      '</span>';
    document.body.appendChild(btn);
  }


  /* SEO + a11y: fill missing alt attributes on <img> with contextual fallback. Idempotent. */
  function ensureImageAlt() {
    document.querySelectorAll('img').forEach(function(img) {
      if (img.alt && img.alt.trim()) return;
      var productLink = img.closest('a[href*="/products/"]');
      if (productLink) {
        var card = productLink.closest('.card-wrapper, .grid__item') || productLink;
        var titleEl = card.querySelector('.card__heading, [class*="card__title"], [class*="product__title"], [class*="product-title"]');
        if (titleEl && titleEl.innerText.trim()) {
          img.alt = titleEl.innerText.trim().slice(0, 120);
          return;
        }
        var ariaLabel = productLink.getAttribute('aria-label');
        if (ariaLabel && ariaLabel.trim()) {
          img.alt = ariaLabel.trim().slice(0, 120);
          return;
        }
      }
      if (img.closest('.product__media, .product-media, [class*="product__media"]')) {
        var h1 = document.querySelector('h1');
        if (h1 && h1.innerText.trim()) {
          img.alt = h1.innerText.trim().slice(0, 120) + ' — Beleaev Caviar';
          return;
        }
      }
      if (img.closest('.header__heading, [class*="header__logo"]') || /logo/i.test(img.src||'') || /logo/i.test(img.className||'')) {
        img.alt = 'Beleaev Caviar & Gourmet';
        return;
      }
      img.alt = '';
    });
  }


  /* Mega menu sits below header without gap. .mega-menu uses position:fixed top:102px hardcoded for index header height (103px). On non-index pages header is shorter (61px) -> 41px gap. Fix: dynamically set top to actual header bottom. */
  function attachMegaMenuToHeader() {
    var header = document.querySelector('[id*="shopify-section-sections--"][id$="__header"]');
    var menu = document.querySelector('section.mega-menu');
    if (!header || !menu) return;
    var pos = window.getComputedStyle(menu).position;
    if (pos !== 'fixed' && pos !== 'sticky') return;
    var hb = header.getBoundingClientRect().bottom;
    if (hb >= 0 && Math.abs((parseFloat(menu.style.top || menu.style.getPropertyValue('top') || '0')) - hb) > 0.5) {
      menu.style.setProperty('top', Math.round(hb) + 'px', 'important');
    }
  }


  /* Mobile overlap fixes for card price-row + trust bar wrap. Idempotent CSS injection. */
  function injectMobileFixCSS() {
    if (document.getElementById('beleaev-mobile-fix-css')) return;
    var style = document.createElement('style');
    style.id = 'beleaev-mobile-fix-css';
    style.textContent = ".product-card-wrapper .card__subtitle, .card-wrapper .card__subtitle, .card__information .card__subtitle, .beleaev-bento .card__subtitle { display: none !important; height: 0 !important; margin: 0 !important; padding: 0 !important; overflow: hidden !important; } .shopify-section.beleaev-trust-bar-wrap, .shopify-section.beleaev-split-wrap, .shopify-section.beleaev-bento-section, .shopify-section.beleaev-recipes-wrap, .shopify-section.section-follow-along { padding-bottom: 0 !important; margin-bottom: 0 !important; } .shopify-section.beleaev-split-wrap, .shopify-section.beleaev-bento-section, .shopify-section.beleaev-recipes-wrap, .shopify-section.section-follow-along { padding-top: 16px !important; margin-top: 0 !important; } .beleaev-trust-bar { padding-bottom: 16px !important; } .beleaev-split, .beleaev-bento, .beleaev-recipes { padding-bottom: 16px !important; } .shopify-section .collection .title-wrapper { margin-bottom: 16px !important; padding-bottom: 0 !important; text-align: center !important; } .shopify-section .collection .collection__title { margin-bottom: 12px !important; padding-bottom: 0 !important; text-align: center !important; width: 100% !important; } .shopify-section .collection .slider, .shopify-section .collection .product-grid { margin-top: 0 !important; padding-top: 0 !important; } .shopify-section .collection { padding-top: 0 !important; padding-bottom: 0 !important; } .card-wrapper, .product-card-wrapper { display: flex !important; flex-direction: column !important; height: 100% !important; } .card-wrapper .card__information, .card-wrapper .card-information { display: flex !important; flex-direction: column !important; flex: 1 1 auto !important; } .card__information .beleaev-price-row, .card-information .beleaev-price-row { margin-top: auto !important; } @media (max-width: 749px) {   .beleaev-price-row { display: flex !important; flex-wrap: nowrap !important; align-items: center !important; gap: 8px !important; min-width: 0 !important; }   .beleaev-price-row > * { min-width: 0 !important; }   .beleaev-price-row .price { flex: 1 1 auto !important; min-width: 0 !important; white-space: normal !important; word-break: keep-all !important; overflow: visible !important; }   .beleaev-price-row .quick-add, .beleaev-price-row .card-information__bag, .beleaev-price-row [class*=\"bag\"] { flex: 0 0 auto !important; position: relative !important; left: auto !important; transform: none !important; }   .card__information .beleaev-price-row, .card-information .beleaev-price-row { margin-top: 8px !important; }   .card__heading { margin-bottom: 4px !important; }   .shopify-section .collection { padding-top: 8px !important; padding-bottom: 8px !important; }   .shopify-section .collection .title-wrapper { padding: 0 !important; margin: 0 0 12px 0 !important; text-align: center !important; display: flex !important; flex-direction: column !important; align-items: center !important; }   .shopify-section .collection .collection__title { margin: 0 !important; padding: 0 !important; text-align: center !important; width: 100% !important; font-size: 1.6rem !important; line-height: 1.2 !important; }   .sommelier-banner__actions { display: flex !important; flex-direction: column !important; align-items: stretch !important; gap: 6px !important; width: 100% !important; }   .sommelier-banner__cta { padding: 9px 16px !important; font-size: 13px !important; width: auto !important; max-width: 220px !important; margin: 0 auto !important; text-align: center !important; }   .sommelier-banner__phone { display: flex !important; flex-direction: column !important; align-items: center !important; gap: 2px !important; width: 100% !important; text-align: center !important; padding: 0 !important; margin-top: 4px !important; }   .sommelier-banner__phone-number { display: block !important; font-size: 15px !important; font-weight: 600 !important; color: #d4af37 !important; line-height: 1.2 !important; }   .sommelier-banner__phone-caption { display: block !important; font-size: 11px !important; opacity: 0.78 !important; line-height: 1.2 !important; }   .shopify-section.beleaev-bento-section { padding-top: 8px !important; padding-bottom: 0 !important; }   .beleaev-bento { padding-top: 0 !important; padding-bottom: 0 !important; }   .beleaev-bento__inner { padding: 0 16px !important; }   .beleaev-bento__head { padding-bottom: 8px !important; margin-bottom: 12px !important; padding-top: 0 !important; }   .beleaev-bento__heading { font-size: 1.5rem !important; line-height: 1.1 !important; margin: 0 !important; padding: 0 !important; text-align: center !important; }   .beleaev-bento__viewall { margin-top: 16px !important; }   .beleaev-trust-bar__grid { display: grid !important; grid-template-columns: repeat(2, 1fr) !important; gap: 18px 12px !important; overflow-x: visible !important; padding-left: 12px !important; padding-right: 12px !important; }   .beleaev-trust-bar__item { width: auto !important; padding: 0 !important; text-align: center !important; box-sizing: border-box !important; }   .beleaev-trust-bar__title { font-size: 0.85rem !important; line-height: 1.2 !important; margin: 8px 0 4px !important; }   .beleaev-trust-bar__proof { font-size: 0.72rem !important; line-height: 1.3 !important; }   .beleaev-trust-bar__seal { width: 56px !important; height: 56px !important; margin: 0 auto !important; } }";
    document.head.appendChild(style);
  }


  /* Wire enhanced variant picker: on radio change, update hidden form id, price, URL, ATC. Additive, no DOM rewrite. */
  var __beleaevProductCache = null;
  function wireVariantPicker() {
    var labels = document.querySelectorAll(".variant-label");
    if (!labels.length) return;
    labels.forEach(function(l) {
      if (l.closest("quick-add-modal") || l.dataset.beleaevLabelWired) return;
      l.dataset.beleaevLabelWired = "1";
      l.addEventListener("click", function(e) {
        var targetId = l.getAttribute("for");
        if (!targetId) return;
        var target = document.getElementById(targetId);
        if (!target || target.type !== "radio") return;
        e.preventDefault();
        e.stopPropagation();
        applyBeleaevVariant(target, l);
      });
    });
  }
  function applyBeleaevVariant(radio, label) {
    var scope = radio.closest('product-info, [id^="ProductInfo-"], section[id^="MainProduct-"]');
    if (!scope || radio.closest("quick-add-modal")) return;
    var variantId = radio.value;
    scope.querySelectorAll('input[type="radio"]').forEach(function(rr) { if (rr.name === radio.name) rr.checked = false; });
    radio.checked = true;
    scope.querySelectorAll(".variant-label").forEach(function(ll) { ll.classList.remove("beleaev-selected"); });
    if (label) label.classList.add("beleaev-selected");
    var mainAtcBtn = scope.querySelector('.product__info-container .product-form__submit');
    var mainForm = mainAtcBtn ? mainAtcBtn.closest("form") : null;
    var hiddenId = mainForm ? mainForm.querySelector('input[name="id"]') : null;
    if (hiddenId) hiddenId.value = variantId;
    try {
      var url = new URL(location.href);
      url.searchParams.set("variant", variantId);
      history.replaceState({}, "", url);
    } catch (e) {}
    fetchBeleaevProduct(function(product) {
      if (!scope.isConnected || !radio.checked || hiddenId?.value !== variantId || !product || !product.variants) return;
      var variant = product.variants.find(function(v) { return String(v.id) === String(variantId); });
      if (!variant) return;
      var priceEls = scope.querySelectorAll('.product__info-container .price-item--regular, .product__info-container .price__regular .price-item');
      var formattedPrice = "£" + (variant.price / 100).toFixed(2) + " GBP";
      priceEls.forEach(function(el) { el.textContent = formattedPrice; });
      if (mainAtcBtn) {
        mainAtcBtn.disabled = !variant.available;
        var sp = mainAtcBtn.querySelector("span");
        if (sp) sp.textContent = variant.available ? "ADD TO CART" : "SOLD OUT";
      }
      var existingPS = scope.querySelector(".beleaev-per-serving");
      if (scope.dataset.blvPriceOwner !== 'allocation') {
        if (existingPS) existingPS.remove();
        if (typeof addPerServingPrice === "function") addPerServingPrice();
      }
      if (typeof setupQuantityTotal === "function") {
        var qtyInput = scope.querySelector(".product__info-container .quantity__input");
        if (qtyInput) qtyInput.dispatchEvent(new Event("input", {bubbles:true}));
      }
    });
  }
  function onBeleaevVariantChange(e) { /* no-op: handled via label click directly */ }
  function fetchBeleaevProduct(cb) {
    if (__beleaevProductCache) { cb(__beleaevProductCache); return; }
    var match = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!match) return;
    fetch("/products/" + match[1] + ".js", { credentials: "include" })
      .then(function(r) { return r.json(); })
      .then(function(p) { __beleaevProductCache = p; cb(p); })
      .catch(function() {});
  }

  /* Show quantity multiplied price next to qty selector. Updates on qty input or variant change. Idempotent. */
  function setupQuantityTotal() {
    if (!document.body.classList.contains("template-product") && !document.querySelector(".product__info-container")) return;
    var qtyInput = document.querySelector(".product__info-container .quantity__input, .product__info-container input[name=\"quantity\"]");
    if (!qtyInput) return;
    if (qtyInput.dataset.beleaevQtyTotal) return;
    qtyInput.dataset.beleaevQtyTotal = "1";
    var totalEl = document.createElement("span");
    totalEl.className = "beleaev-qty-total";
    totalEl.style.cssText = "display:inline-block;margin-left:14px;font-weight:600;color:#d4af37;white-space:nowrap;align-self:center;font-size:1.05em;";
    var qtyContainer = qtyInput.closest("quantity-input, .quantity, .product-form__quantity-top") || qtyInput.parentElement;
    if (qtyContainer && qtyContainer.parentElement) {
      qtyContainer.parentElement.insertBefore(totalEl, qtyContainer.nextSibling);
    }
    function getCurrentPrice() {
      var owned = document.querySelector('[data-blv-price-owner="allocation"] beleaev-subscription-prices:not([hidden])');
      if (owned) return Number(owned.dataset.unitCents) / 100;
      var priceEl = document.querySelector(".product__info-container .price-item--regular, .product__info-container .price-item.price-item--regular");
      if (!priceEl) return 0;
      var match = priceEl.innerText.replace(/,/g, "").match(/([0-9]+(?:.[0-9]+)?)/);
      return match ? parseFloat(match[1]) : 0;
    }
    function updateTotal() {
      var qty = parseInt(qtyInput.value, 10) || 1;
      var price = getCurrentPrice();
      if (price <= 0) { totalEl.textContent = ""; return; }
      if (qty <= 1) { totalEl.textContent = ""; return; }
      var owned = document.querySelector('[data-blv-price-owner="allocation"] beleaev-subscription-prices:not([hidden])');
      var total = owned
        ? new Intl.NumberFormat(owned.dataset.locale, { style: 'currency', currency: owned.dataset.currency }).format(price * qty)
        : "£" + (price * qty).toFixed(2);
      totalEl.textContent = "= " + total;
    }
    qtyInput.addEventListener("input", updateTotal);
    qtyInput.addEventListener("change", updateTotal);
    qtyInput.closest('product-info, [id^="ProductInfo-"]')?.addEventListener('beleaev:display-price-change', updateTotal);
    var qContainer = qtyInput.closest("quantity-input, .quantity");
    if (qContainer) {
      qContainer.querySelectorAll("button.quantity__button, button[name=\"plus\"], button[name=\"minus\"]").forEach(function(b) {
        b.addEventListener("click", function() { setTimeout(updateTotal, 80); });
      });
    }
    document.querySelectorAll("input[type=\"radio\"][name=\"variant\"]").forEach(function(r) {
      r.addEventListener("change", function() { setTimeout(updateTotal, 700); });
    });
    updateTotal();
  }

  /* Hide product card subtitles via inline style (beats any external !important rule). Idempotent. */
  function hideCardSubtitles() {
    var isHome = document.body.classList.contains("template-index") || location.pathname === "/" || location.pathname === "";
    if (isHome) {
      document.querySelectorAll(".card__subtitle").forEach(function(s) { s.style.removeProperty("display"); });
      return;
    }
    document.querySelectorAll(".card__subtitle").forEach(function(s) {
      s.style.setProperty("display", "none", "important");
    });
  }

  /* Cleanup: убираем inline-стили которые раньше принудительно прижимали
     price-row к низу карточки (создавали большой gap между описанием и ценой
     когда subtitle короткий). Layout теперь полностью управляется CSS из
     card-product.liquid {% style %}. */
  function alignCardPriceRows() {
    document.querySelectorAll(".card-wrapper, .product-card-wrapper").forEach(function(card) {
      var priceRow = card.querySelector(".beleaev-price-row");
      if (!priceRow) return;
      // Remove inline overrides set by older versions
      var info = card.querySelector(".card__information");
      var info2 = card.querySelector(".card-information");
      [card, info, info2, priceRow.parentElement].forEach(function(el) {
        if (!el) return;
        el.style.removeProperty("display");
        el.style.removeProperty("flex-direction");
        el.style.removeProperty("flex");
      });
      priceRow.style.removeProperty("margin-top");
    });
  }
  /* === Beleaev qty submission fix (2026-05-04) ===
   * Bug: PDP renders TWO <form id="product-form-{section.id}"> with same ID:
   *   1) inline form in main-product.liquid (always rendered)
   *   2) form in buy_buttons block via buy-buttons.liquid (Shop Pay support)
   * <input form="..."> on the qty input binds to the FIRST form via
   * getElementById. When user clicks the OTHER form's submit button, the
   * browser's FormData(otherForm) excludes the qty input — so /cart/add
   * receives default quantity=1 regardless of selected qty. Same problem
   * occurs inside the quick-add modal (PDP HTML cloned with ids prefixed).
   *
   * Fix: capture-phase document-level submit listener. Before product-form.js
   * submit handler runs (bubble phase), if the submitting /cart/add form has
   * no form-associated quantity input with value > 0, inject a hidden
   * <input name="quantity"> as a direct child of the form with the visible
   * page qty value. Idempotent. Additive — does NOT touch Tatiana's custom
   * code, theme liquid, or template JSON. */
  function installQtySubmissionFix() {
    if (window.__beleaevQtyFixInstalled) return;

    function getVisibleQty() {
      var inputs = document.querySelectorAll('input[name="quantity"][type="number"]');
      var fallback = 1;
      for (var i = 0; i < inputs.length; i++) {
        var el = inputs[i];
        var v = parseInt(el.value || '1', 10);
        if (!(v > 0)) continue;
        var rect = el.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0) return v;
        if (i === 0) fallback = v;
      }
      return fallback;
    }

    function onSubmitCapture(e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;

      // Does the form already own a usable, non-disabled quantity input
      // (descendant or form="..." associated)?
      var hasQty = false;
      try {
        var existing = form.elements && form.elements.namedItem
          ? form.elements.namedItem('quantity')
          : null;
        if (existing) {
          var first = existing.length !== undefined && existing[0] ? existing[0] : existing;
          if (!first.disabled) {
            var vv = parseInt(first.value || '0', 10);
            if (vv > 0) hasQty = true;
          }
        }
      } catch (err) { /* defensive */ }

      if (hasQty) return;

      var qty = getVisibleQty();
      var hidden = form.querySelector('input[name="quantity"][data-beleaev-qty-fix]');
      if (!hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'quantity';
        hidden.setAttribute('data-beleaev-qty-fix', '1');
        form.appendChild(hidden);
      }
      hidden.value = String(qty);
    }

    document.addEventListener('submit', onSubmitCapture, true); // capture phase
    window.__beleaevQtyFixInstalled = true;
  }

  /* Quick Add modal fix (2026-05-04): mirrors the visible quantity input and
   * the selected variant into the form's hidden inputs in real time. Origin
   * theme renders the qty input as a sibling of the form (HTML5 form-association
   * is broken in this template), so the form submits qty=1 by default and
   * adds the wrong variant when the user selects a different size in the modal.
   * This fix patches both at the source (additive, scoped per modal). */
  function wireQuickAddModals() {
    document.querySelectorAll('quick-add-modal').forEach(function(modal) {
      var selected = modal.querySelector('.variant-input:checked');
      var quantity = modal.querySelector('quantity-input input[name="quantity"]');
      var association = selected ? selected.getAttribute('form') : quantity && quantity.getAttribute('form');
      var root = (selected || quantity)?.closest('product-info, [id^="ProductInfo-"]');
      var productId = root && root.dataset.productId;
      if (!association || !productId) return;
      var form = Array.from(modal.querySelectorAll('form[action*="/cart/add"]')).find(function(candidate) {
        var owner = candidate.querySelector('input[name="product-id"]');
        return candidate.getAttribute('id') === association && owner && owner.value === productId && root.contains(candidate);
      });
      if (!form || form.dataset.beleaevQaWired === '1') return;
      form.dataset.beleaevQaWired = '1';

      var visibleQty = modal.querySelector('input.quantity__input, input[name="quantity"][type="number"]');
      var formId = form.querySelector('input[name="id"]');

      // 1) Mirror visible qty into hidden form input (kept in sync on every change).
      var hiddenQty = null;
      if (visibleQty && !form.contains(visibleQty)) {
        hiddenQty = form.querySelector('input[name="quantity"][data-beleaev-qty-mirror]');
        if (!hiddenQty) {
          hiddenQty = document.createElement('input');
          hiddenQty.type = 'hidden';
          hiddenQty.name = 'quantity';
          hiddenQty.setAttribute('data-beleaev-qty-mirror', '1');
          form.appendChild(hiddenQty);
        }
        var syncQty = function() {
          var v = parseInt(visibleQty.value, 10);
          hiddenQty.value = (v > 0) ? String(v) : '1';
        };
        visibleQty.addEventListener('input', syncQty);
        visibleQty.addEventListener('change', syncQty);
        modal.querySelectorAll('button[name="plus"], button[name="minus"], .quantity__button').forEach(function(b) {
          b.addEventListener('click', function() { setTimeout(syncQty, 60); });
        });
        syncQty();
      }

      // 2) Sync variant id to form's hidden id input on label click (capture phase
      //    so it runs before applyBeleaevVariant's stopPropagation).
      modal.querySelectorAll('.variant-label').forEach(function(label) {
        label.addEventListener('click', function() {
          var radioId = label.getAttribute('for');
          if (!radioId || !formId) return;
          var radio = modal.querySelector('#' + (CSS && CSS.escape ? CSS.escape(radioId) : radioId.replace(/([^\w-])/g,'\\$1')));
          if (radio && radio.value) formId.value = radio.value;
        }, true);
      });

      // 3) Belt-and-suspenders: re-sync at submit time.
      form.addEventListener('submit', function() {
        if (visibleQty && hiddenQty) {
          var v = parseInt(visibleQty.value, 10);
          hiddenQty.value = (v > 0) ? String(v) : '1';
        }
        var checked = modal.querySelector('input[name="variant"]:checked, input.variant-input:checked');
        if (checked && formId) formId.value = checked.value;
      }, true);
    });
  }

  /* === Beleaev qty mirror across duplicate inputs (2026-05-04) ===
   * Bug: on some PDPs (e.g. Golden Oscietra), the section renders TWO
   * <quantity-input> elements with the same id="Quantity-{section.id}",
   * both inside .product-form__buttons of two same-id forms. User typing in
   * one input doesn't mirror to the other — the visible "+/- N" widgets
   * desync. Sync values so any change propagates to all qty inputs in the
   * same product scope. Document-level event delegation — robust against
   * late DOM mutations (variant change re-renders, modal late-injection).
   * Idempotent. Additive — does NOT touch Tatiana's custom code.
   * Complements wireQuickAddModals (visible→hidden inside ONE form) by
   * syncing across MULTIPLE visible duplicates. */
  function setupQtyMirror() {
    if (window.__beleaevQtyMirrorInstalled) return;
    window.__beleaevQtyMirrorInstalled = true;
    function syncAcrossScope(target) {
      if (window.__beleaevMirroring) return;
      if (!target || !target.matches) return;
      if (!target.matches('input[name="quantity"][type="number"]')) return;
      var scope = target.closest('quick-add-modal, product-info, section[id^="MainProduct-"]');
      if (!scope) return;
      var siblings = scope.querySelectorAll('input[name="quantity"][type="number"]');
      if (siblings.length < 2) return;
      window.__beleaevMirroring = true;
      try {
        var v = target.value;
        Array.prototype.forEach.call(siblings, function (inp) {
          if (inp !== target && inp.value !== v) {
            inp.value = v;
            inp.dispatchEvent(new Event('input', { bubbles: true }));
            inp.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      } finally {
        window.__beleaevMirroring = false;
      }
    }
    document.addEventListener('input', function (e) { syncAcrossScope(e.target); }, true);
    document.addEventListener('change', function (e) { syncAcrossScope(e.target); }, true);
  }

  /* === Beleaev free-shipping format consistency (2026-05-04) ===
   * Bug: cart-drawer.liquid renders "£163.00 left to enjoy free delivery!" via
   * Liquid `| money` filter, but its inline JS updateFreeShippingBar uses
   * Shopify.formatMoney (returns "163.00£", suffix £) AND different copy
   * ("away from free shipping!"). After any cart change the text reformats,
   * creating jank that founder reports as "architecture breaks".
   * Fix: monkey-patch updateFreeShippingBar to render the same prefix
   * format and copy as the Liquid render. Additive — does not edit
   * cart-drawer.liquid. */
  function installFreeShippingFormatFix() {
    if (window.__beleaevFsFormatFixInstalled) return;
    function fmt(amountCents) {
      var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
      var prefix, decSep;
      switch (code) {
        case 'EUR': prefix = '€'; decSep = ','; break;
        case 'USD': prefix = '$'; decSep = '.'; break;
        case 'GBP': prefix = '£'; decSep = '.'; break;
        case 'AED': prefix = 'AED '; decSep = '.'; break;
        default:    prefix = code + ' '; decSep = '.';
      }
      var n = (amountCents / 100).toFixed(2);
      if (decSep === ',') n = n.replace('.', ',');
      return prefix + n;
    }
    function applyOverride() {
      if (typeof window.updateFreeShippingBar !== 'function') return false;
      if (window.updateFreeShippingBar.__beleaevPatched) return true;
      var orig = window.updateFreeShippingBar;
      var patched = function (cart) {
        var container = document.querySelector('.free-shipping-container');
        if (!container || !cart) return orig.apply(this, arguments);
        container.hidden = !Array.isArray(cart.items) || !cart.items.some(function (item) { return item.requires_shipping === true && item.quantity > 0; });
        if (container.hidden) return;
        var threshold = parseInt(container.getAttribute('data-threshold'), 10);
        var lang = container.getAttribute('data-lang') || 'en';
        var total = cart.total_price || 0;
        var count = cart.item_count || 0;
        var remaining = threshold - total;
        var progress = Math.min((total / threshold) * 100, 100);
        var textElement = container.querySelector('.fs-text');
        var fillElement = container.querySelector('.fs-progress-fill');
        if (fillElement) fillElement.style.width = progress + '%';
        if (!textElement) return;
        var formatted = fmt(remaining);
        var copy;
        if (count === 0 || total === 0) {
          if (lang === 'de') copy = 'Fügen Sie Artikel hinzu, um <strong>kostenlosen Versand</strong> ab ' + fmt(threshold) + ' zu erhalten!';
          else if (lang === 'es') copy = '¡Añade artículos para obtener <strong>envío gratis</strong> a partir de ' + fmt(threshold) + '!';
          else copy = 'Add items to get <strong class="beleaev-free-delivery-label">Free Next Day Delivery</strong> over ' + fmt(threshold) + '!';
        } else if (remaining > 0) {
          if (lang === 'de') copy = 'Nur noch <strong>' + formatted + '</strong> bis zum kostenlosen Versand!';
          else if (lang === 'es') copy = '¡Solo faltan <strong>' + formatted + '</strong> para disfrutar de envío gratis!';
          else copy = 'Only <strong>' + formatted + '</strong> left to enjoy <strong class="beleaev-free-delivery-label">Free Next Day Delivery</strong>!';
        } else {
          if (lang === 'de') copy = 'Sie haben den <strong>kostenlosen Versand</strong> freigeschaltet!';
          else if (lang === 'es') copy = '¡Has desbloqueado el <strong>envío gratuito!</strong>';
          else copy = "You've unlocked <strong class=\"beleaev-free-delivery-label\">Free Next Day Delivery</strong>!";
        }
        textElement.innerHTML = copy;
      };
      patched.__beleaevPatched = true;
      window.updateFreeShippingBar = patched;
      return true;
    }
    if (!applyOverride()) {
      var attempts = 0;
      var iv = setInterval(function () {
        attempts++;
        if (applyOverride() || attempts > 20) clearInterval(iv);
      }, 200);
    }
    window.__beleaevFsFormatFixInstalled = true;
  }

  function runAll() {
    restructure();
    wrapFromPrefix();
    inlineBagWithPrice();
    liftFromLabelMobile();
    wrapCardCurrencyCodes();
    addProductBadges();
    decorateBritishQualityControl();
    ensureHomepageH1();
    injectPaymentIcons();
    setupStickyMobileATC();
    addPerServingPrice();
    ensureCardClickable();
    addPdpSommelierBubble();
    wireVariantPicker();
    setupQuantityTotal();
    attachMegaMenuToHeader();
    injectMobileFixCSS();
    ensureImageAlt();
    hideCardSubtitles();
    alignCardPriceRows();
    installQtySubmissionFix();
    wireQuickAddModals();
    setupQtyMirror();
    installFreeShippingFormatFix();
    injectCartDrawerEmptyFix();
  }

  /* === Beleaev cart drawer empty-state fix (2026-05-04, v2) ===
   * Bug: When cart becomes empty, multiple elements overlap visually:
   *  1) <cart-drawer-items class="is-empty"> stays h=1838px at y=-175 (huge
   *     upward overflow) and renders the upsell list through entire drawer.
   *  2) drawer__inner-empty (Tatiana's "Your cart is empty" message) gets
   *     placed in CSS Grid row 1 (280px) but its content is 317px → spills.
   *  3) free-shipping bar shows the wrong message stacked at top.
   *  4) Result: "Continue shopping" pill, "Your cart" text, and X close all
   *     float on top of the upsell list, looking broken.
   * Fix v2: When .is-empty, force a clean linear stack via flex column on
   *  drawer__inner: header → empty message → upsell list. Hide overflowing
   *  free-shipping. Constrain cart-drawer-items height + clear its negative
   *  offset so upsell sits BELOW empty message, not on top of it.
   * Idempotent. Additive. */
  function injectCartDrawerEmptyFix() {
    if (document.getElementById('beleaev-cart-empty-fix-css')) return;
    var css = [
      /* Switch grid → flex stack when cart is empty so source order is honoured */
      'cart-drawer.is-empty .drawer__inner {',
      '  display: flex !important;',
      '  flex-direction: column !important;',
      '  grid-template-rows: none !important;',
      '  grid-template-columns: none !important;',
      '}',
      /* Header first, normal height */
      'cart-drawer.is-empty .drawer__header {',
      '  order: 0 !important;',
      '  display: flex !important;',
      '  position: relative !important;',
      '  top: 0 !important;',
      '}',
      /* Empty-state message second, no min-height clamp, no negative Y */
      'cart-drawer.is-empty .drawer__inner-empty {',
      '  order: 1 !important;',
      '  position: relative !important;',
      '  top: 0 !important;',
      '  height: auto !important;',
      '  min-height: 0 !important;',
      '  max-height: none !important;',
      '  padding: 32px 20px 24px !important;',
      '  margin: 0 !important;',
      '  overflow: visible !important;',
      '  flex: 0 0 auto !important;',
      '  display: flex !important;',
      '  flex-direction: column !important;',
      '  align-items: center !important;',
      '  justify-content: flex-start !important;',
      '}',
      'cart-drawer.is-empty .drawer__inner-empty .cart-drawer__warnings {',
      '  width: 100% !important;',
      '  text-align: center !important;',
      '  gap: 14px !important;',
      '}',
      /* Upsell area (cart-drawer-items) third, normal flow, no negative Y */
      'cart-drawer.is-empty cart-drawer-items {',
      '  order: 2 !important;',
      '  position: relative !important;',
      '  top: 0 !important;',
      '  height: auto !important;',
      '  max-height: none !important;',
      '  margin: 0 !important;',
      '  flex: 1 1 auto !important;',
      '  overflow-y: auto !important;',
      '}',
      'cart-drawer.is-empty cart-drawer-items::before {',
      '  content: "" !important;',
      '  display: block !important;',
      '  border-top: 1px solid rgba(255,255,255,0.1) !important;',
      '  margin: 8px 16px 0 !important;',
      '}',
      /* Hide free-shipping when cart is empty */
      'cart-drawer.is-empty .free-shipping-container {',
      '  display: none !important;',
      '}'
    ].join('\n');
    var style = document.createElement('style');
    style.id = 'beleaev-cart-empty-fix-css';
    style.textContent = css;
    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }

  /* BELEAEV_INP_OPTIMIZATION_2026_08_30: keep dynamic-card support without rescanning the whole page
     ten times after load or after every unrelated third-party DOM mutation. */
  function runDynamicEnhancements() {
    wrapFromPrefix();
    inlineBagWithPrice();
    liftFromLabelMobile();
    wrapCardCurrencyCodes();
    addProductBadges();
    injectPaymentIcons();
    ensureCardClickable();
    hideCardSubtitles();
    alignCardPriceRows();
    restructure();
    wireQuickAddModals();
  }

  document.addEventListener('beleaev:quick-add-ready', runDynamicEnhancements);

  let dynamicPending = false;
  function scheduleDynamicEnhancements() {
    if (dynamicPending) return;
    dynamicPending = true;
    const execute = () => {
      dynamicPending = false;
      runDynamicEnhancements();
    };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(execute, { timeout: 500 });
    } else {
      setTimeout(execute, 60);
    }
  }

  window.addEventListener('load', function () {
    setTimeout(scheduleDynamicEnhancements, 600);
    setTimeout(scheduleDynamicEnhancements, 2000);
  }, { once: true });

  let resizePending = false;
  window.addEventListener('resize', function () {
    if (resizePending) return;
    resizePending = true;
    requestAnimationFrame(function () {
      resizePending = false;
      attachMegaMenuToHeader();
      liftFromLabelMobile();
    wrapCardCurrencyCodes();
    });
  });

  /* Only product/cart insertions need enhancement work. */
  if (typeof MutationObserver !== 'undefined') {
    const dynamicSelector = '.card-wrapper, .product-card-wrapper, quick-add-modal, cart-drawer, #CartDrawer';
    const mo = new MutationObserver((records) => {
      const relevant = records.some((record) => Array.from(record.addedNodes).some((node) => (
        node.nodeType === 1 && (
          (node.matches && node.matches(dynamicSelector)) ||
          (node.querySelector && node.querySelector(dynamicSelector))
        )
      )));
      if (relevant) scheduleDynamicEnhancements();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  /* Curator badge restore after QUICK-ADD closes (fix 2026-06-04).
   * Opening quick-add relocates a grid card's .beleaev-badge into the
   * cloned modal; on close the modal clears its content (innerHTML='')
   * and the badge is gone from the grid until the next page load. The
   * rAF-based observer above does not fire while the tab is throttled,
   * so re-inject explicitly on the 'modalClosed' event (dispatched by
   * ModalDialog.hide -> super.hide) using setTimeout (visibility-proof).
   * runAll() is idempotent (skips cards that already have a badge). */
  document.body.addEventListener('modalClosed', function () {
    setTimeout(scheduleDynamicEnhancements, 60);
    setTimeout(scheduleDynamicEnhancements, 350);
  });
})();

/* ============================================
   Judge.me preview_badge click → scroll to review widget
   (added 2026-05-14 — fixes mobile click on stars under
   product title landing on "More to enjoy" instead of
   jdgm-rev-widg. Capture phase intercepts before Judge.me)
   ============================================ */
(function () {
  'use strict';
  var HEADER_OFFSET = 80;
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('.jdgm-prev-badge, .jdgm-prev-badge__stars, .jdgm-prev-badge__text');
    if (!trigger) return;
    var target = document.querySelector('.jdgm-rev-widg__title, .jdgm-rev-widg, .jdgm-review-widget, [data-from-snippet="review_widget"]');
    if (!target) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var y = target.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }, true);
})();


/* October 2026 caviar promotion: prices, collection cards and badges. */
(function () {
  'use strict';
  return; var PROMO = window.BeleaevOctoberPromo = Object.assign(window.BeleaevOctoberPromo || {}, {
    'almaz-diamond-caviar': [[16300,14670,10],[27300,23205,15],[68200,57970,15],[136500,116025,15],[546000,464100,15]],
    'almaz-diamond-caviar-set': [[16300,14670,10],[27300,23205,15],[68200,57970,15],[136500,116025,15],[546000,464100,15]],
    'royal-beluga-caviar': [[11000,9900,10],[18000,15300,15],[45000,38250,15],[90000,76500,15],[357000,303450,15]],
    'royal-beluga-caviar-copy': [[11000,9900,10],[18000,15300,15],[45000,38250,15],[90000,76500,15],[357000,303450,15]],
    'beluga-caviar-set': [[11000,9900,10],[18000,15300,15],[45000,38250,15],[90000,76500,15],[357000,303450,15]],
    'beluga-xxl-special-reserve': [[13100,11790,10],[21800,18530,15],[54600,46410,15],[109200,92820,15],[436800,371280,15]],
    'beluga-xxl-caviar-set': [[13100,11790,10],[21800,18530,15],[54600,46410,15],[109200,92820,15],[436800,371280,15]],
    'golden-oscietra-special-reserve': [[5100,4590,10],[8100,6885,15],[20000,16000,20],[39400,31520,20],[157500,126000,20]],
    'golden-oscietra-caviar-set': [[5100,4590,10],[8100,6885,15],[20000,17000,15],[39400,33490,15],[157500,133875,15]],
    'royal-imperial-caviar': [[5200,4680,10],[8500,7225,15],[21000,17850,15],[42700,36295,15],[171000,145350,15]],
    'royal-imperial-caviar-copy': [[5200,4680,10],[8500,7225,15],[21000,17850,15],[42700,36295,15],[171000,145350,15]],
    'royal-oscietra-caviar': [[4800,4320,10],[7800,6630,15],[19500,15600,20],[39000,31200,20],[147000,117600,20]],
    'royal-oscietra-caviar-copy': [[4800,4320,10],[7800,6630,15],[19500,15600,20],[39000,31200,20],[147000,117600,20]],
    'royal-baerii-caviar': [[3700,3330,10],[6300,5355,15],[15700,12560,20],[31500,25200,20],[122000,97600,20]],
    'baeri-festive-caviar-set': [[3700,3330,10],[6300,5355,15],[15700,13345,15],[31500,26775,15],[122000,103700,15]],
    'wild-salmon-roe': [[7200,6120,15],[18000,15300,15]],
    'wild-salmon-festive-caviar-set': [[7200,6120,15],[18000,15300,15]],
    'caviar-brunch-box': [[7695,6541,15]],
    'happy-birthday-hamper': [[7753,6590,15]],
    'caviar-birthday-gift': [[7753,6590,15]],
    'the-grand-caviar-board': [[25575,21739,15]],
    'beluga-caviar-gift-board': [[25575,21739,15]],
    'the-beleaev-signature-tasting-set-4x125g': [[99900,84915,15]],
    'the-beleaev-signature-tasting-set': [[24700,20995,15]],
    'the-beleaev-signature-tasting-set-4x50g': [[39900,33915,15]]
  });
  function money(cents) { return '£' + (cents / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function handle(card) {
    var link = card.querySelector('a[href*="/products/"]');
    var match = link && link.getAttribute('href').match(/\/products\/([^?#/]+)/);
    return match && match[1];
  }
  function decorate(card) {
    var key = handle(card), rows = key && PROMO[key];
    if (!rows || card.classList.contains('beleaev-oct-card')) return;
    var lowest = rows.reduce(function (best, row) { return row[1] < best[1] ? row : best; }, rows[0]);
    var maximum = rows.reduce(function (best, row) { return Math.max(best, row[2]); }, 0);
    var media = card.querySelector('.card__media, .card__inner, .media') || card;
    var price = card.querySelector('.price');
    var target = card.querySelector('.beleaev-price-row') || card.querySelector('.card__information, .card-information, .card__content') || card;
    card.classList.add('beleaev-oct-card');
    if (price) price.style.display = 'none';
    var badge = document.createElement('span');
    badge.className = 'beleaev-oct-badge';
    badge.textContent = 'SAVE UP TO ' + maximum + '%';
    media.appendChild(badge);
    var visual = document.createElement('div');
    visual.className = 'beleaev-oct-card-price';
    visual.innerHTML = '<span class="beleaev-oct-was">From ' + money(lowest[0]) + '</span><span class="beleaev-oct-now">' + money(lowest[1]) + '</span>';
    target.appendChild(visual);
    if (target.classList.contains('beleaev-price-row')) {
      var quickAdd = target.querySelector(':scope > .quick-add');
      var nativePrice = target.querySelector(':scope > .price');
      if (quickAdd) target.insertBefore(visual, quickAdd);
      if (nativePrice) nativePrice.style.setProperty('display', 'none', 'important');
      var liftedLabel = target.querySelector(':scope > .beleaev-from-label-mobile');
      target.style.setProperty('display', 'flex', 'important');
      ['grid-template-columns', 'grid-template-areas', 'column-gap', 'row-gap'].forEach(function (property) { target.style.removeProperty(property); });
      target.style.setProperty('align-items', 'center', 'important');
      target.style.setProperty('justify-content', 'space-between', 'important');
      target.style.setProperty('gap', '0.6rem', 'important');
      if (liftedLabel) liftedLabel.style.setProperty('display', 'none', 'important');
      visual.style.setProperty('flex', '1 1 auto', 'important');
      visual.style.setProperty('min-width', '0', 'important');
      if (quickAdd) {
        ['grid-area', 'align-self', 'position', 'inset'].forEach(function (property) { quickAdd.style.removeProperty(property); });
        quickAdd.style.setProperty('position', 'relative', 'important');
        quickAdd.style.setProperty('inset', 'auto', 'important');
        quickAdd.style.setProperty('flex', '0 0 auto', 'important');
      }
    }
  }
  function decorateCards(root) {
    (root || document).querySelectorAll('.card-wrapper.product-card-wrapper').forEach(decorate);
  }
  function installStyle() {
    if (document.getElementById('beleaev-october-card-style')) return;
    var style = document.createElement('style');
    style.id = 'beleaev-october-card-style';
    style.textContent = '.beleaev-oct-card{position:relative}.beleaev-oct-badge{position:absolute;z-index:4;left:8px;bottom:8px;padding:5px 8px;border-radius:999px;background:#d5ad4d;color:#050505;font:700 10px/1 var(--font-body-family);letter-spacing:.04em}.beleaev-oct-card-price{display:flex;align-items:baseline;gap:7px;white-space:nowrap;margin-top:7px;font-family:var(--font-body-family)}.beleaev-oct-was{color:rgba(var(--color-foreground),.62);text-decoration:line-through}.beleaev-oct-now{color:#d5ad4d;font-weight:700}@media(max-width:749px){.beleaev-oct-badge{font-size:8px;padding:4px 6px}.beleaev-oct-card-price{gap:5px;font-size:.92rem}}';
    document.head.appendChild(style);
  }
  (function () {
    if (window.__beleaevOctoberOneTimePromo) return;
    window.__beleaevOctoberOneTimePromo = true;
    function money(cents) { return '\u00a3' + (cents / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function ensureStyle() {
      if (document.getElementById('beleaev-october-one-time-style')) return;
      var style = document.createElement('style');
      style.id = 'beleaev-october-one-time-style';
      style.textContent = '#MainContent .appstle_one_time_details_wrapper .appstle_one_time_price_wrapper{display:none!important}#MainContent .appstle_subscription_wrapper_option .beleaev-oct-one-time{display:table!important;margin:5px 0 0 28px!important;padding:3px 8px!important;border:1px solid #c9a961!important;border-radius:999px!important;color:#c9a961!important;font:700 10px/1.15 var(--font-body-family)!important;letter-spacing:.04em!important;white-space:nowrap!important}#MainContent .appstle_subscription_wrapper_option .beleaev-oct-one-time-price{display:inline-flex!important;align-items:baseline!important;gap:5px!important;margin:0 0 0 auto!important;font-family:var(--font-body-family)!important;font-size:16px!important;white-space:nowrap!important}.beleaev-oct-one-time-price .beleaev-oct-was{text-decoration:line-through;color:rgba(255,255,255,.72)}.beleaev-oct-one-time-price .beleaev-oct-now{color:#c9a961;font-weight:700}';
      document.head.appendChild(style);
    }
    function apply() {
      var match = location.pathname.match(/^\/products\/([^?#/]+)/), handle = match && match[1], rows = window.BeleaevOctoberPromo && window.BeleaevOctoberPromo[handle];
      var selected = document.querySelector('.variant-input:checked'), dataNode = document.querySelector('beleaev-purchase-options script[type="application/json"]'), data = null;
      if (!selected && rows && dataNode) try {
        data = JSON.parse(dataNode.textContent);
        if (data.variants && data.variants.length === 1) selected = { value: String(data.variants[0].id) };
      } catch (error) {}
      var cache = window.__beleaevOctoberRowsByVariant || (window.__beleaevOctoberRowsByVariant = {}), key = selected && handle + ':' + selected.value;
      if (!selected || !rows) return;
      if (!Object.prototype.hasOwnProperty.call(cache, key)) {
        fetch('/products/' + handle + '.js').then(function (response) { return response.json(); }).then(function (product) {
          var variant = product.variants.filter(function (item) { return String(item.id) === String(selected.value); })[0];
          cache[key] = variant ? (rows.filter(function (item) { return item[0] === variant.price; })[0] || null) : null;
          apply();
        }).catch(function () { cache[key] = null; });
        return;
      }
      var row = cache[key];
      var option = Array.prototype.slice.call(document.querySelectorAll('.appstle_subscription_wrapper_option')).filter(function (item) { return !!item.querySelector('.appstle_one_time_details_wrapper'); })[0];
      if (!row || !option) return;
      ensureStyle();
      var badge = option.querySelector('.beleaev-oct-one-time');
      if (!badge) { badge = document.createElement('span'); badge.className = 'beleaev-oct-one-time'; (option.querySelector('.appstle_radio_label') || option).appendChild(badge); }
      badge.textContent = 'CAVIAR - ' + row[2] + '%';
      var visual = option.querySelector('.beleaev-oct-one-time-price');
      if (!visual) { visual = document.createElement('span'); visual.className = 'beleaev-oct-one-time-price'; option.querySelector('.appstle_one_time_details_wrapper').appendChild(visual); }
      visual.innerHTML = '<span class="beleaev-oct-was">' + money(row[0]) + '</span><span class="beleaev-oct-now">' + money(row[1]) + '</span>';
    }
    apply();
    var queued = false;
    new MutationObserver(function () { if (!queued) { queued = true; requestAnimationFrame(function () { queued = false; apply(); }); } }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('change', function () { window.setTimeout(apply, 0); });
  }());
  function boot() { installStyle(); decorateCards(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  new MutationObserver(function (records) { records.forEach(function (record) { record.addedNodes.forEach(function (node) { if (node.nodeType === 1) decorateCards(node); }); }); }).observe(document.documentElement, { childList: true, subtree: true });
}());


/* October 2026 caviar promotion: prices, collection cards and badges. */
(function () {
  'use strict';
  return; var PROMO = window.BeleaevOctoberPromo = Object.assign(window.BeleaevOctoberPromo || {}, {
    'almaz-diamond-caviar': [[16300,14670,10],[27300,23205,15],[68200,57970,15],[136500,116025,15],[546000,464100,15]],
    'almaz-diamond-caviar-set': [[16300,14670,10],[27300,23205,15],[68200,57970,15],[136500,116025,15],[546000,464100,15]],
    'royal-beluga-caviar': [[11000,9900,10],[18000,15300,15],[45000,38250,15],[90000,76500,15],[357000,303450,15]],
    'royal-beluga-caviar-copy': [[11000,9900,10],[18000,15300,15],[45000,38250,15],[90000,76500,15],[357000,303450,15]],
    'beluga-caviar-set': [[11000,9900,10],[18000,15300,15],[45000,38250,15],[90000,76500,15],[357000,303450,15]],
    'beluga-xxl-special-reserve': [[13100,11790,10],[21800,18530,15],[54600,46410,15],[109200,92820,15],[436800,371280,15]],
    'beluga-xxl-caviar-set': [[13100,11790,10],[21800,18530,15],[54600,46410,15],[109200,92820,15],[436800,371280,15]],
    'golden-oscietra-special-reserve': [[5100,4590,10],[8100,6885,15],[20000,16000,20],[39400,31520,20],[157500,126000,20]],
    'golden-oscietra-caviar-set': [[5100,4590,10],[8100,6885,15],[20000,17000,15],[39400,33490,15],[157500,133875,15]],
    'royal-imperial-caviar': [[5200,4680,10],[8500,7225,15],[21000,17850,15],[42700,36295,15],[171000,145350,15]],
    'royal-imperial-caviar-copy': [[5200,4680,10],[8500,7225,15],[21000,17850,15],[42700,36295,15],[171000,145350,15]],
    'royal-oscietra-caviar': [[4800,4320,10],[7800,6630,15],[19500,15600,20],[39000,31200,20],[147000,117600,20]],
    'royal-oscietra-caviar-copy': [[4800,4320,10],[7800,6630,15],[19500,15600,20],[39000,31200,20],[147000,117600,20]],
    'royal-baerii-caviar': [[3700,3330,10],[6300,5355,15],[15700,12560,20],[31500,25200,20],[122000,97600,20]],
    'baeri-festive-caviar-set': [[3700,3330,10],[6300,5355,15],[15700,13345,15],[31500,26775,15],[122000,103700,15]],
    'wild-salmon-roe': [[7200,6120,15],[18000,15300,15]],
    'wild-salmon-festive-caviar-set': [[7200,6120,15],[18000,15300,15]],
    'caviar-brunch-box': [[7695,6541,15]],
    'happy-birthday-hamper': [[7753,6590,15]],
    'caviar-birthday-gift': [[7753,6590,15]],
    'the-grand-caviar-board': [[25575,21739,15]],
    'beluga-caviar-gift-board': [[25575,21739,15]],
    'the-beleaev-signature-tasting-set-4x125g': [[99900,84915,15]],
    'the-beleaev-signature-tasting-set': [[24700,20995,15]],
    'the-beleaev-signature-tasting-set-4x50g': [[39900,33915,15]]
  });
  function money(cents) { return '£' + (cents / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function handle(card) {
    var link = card.querySelector('a[href*="/products/"]');
    var href = link && link.getAttribute('href');
    var match = href && href.match(new RegExp('/products/([^?#/]+)'));
    return match && match[1];
  }
  function decorate(card) {
    var key = handle(card), rows = key && PROMO[key];
    if (!rows || card.classList.contains('beleaev-oct-card')) return;
    var lowest = rows.reduce(function (best, row) { return row[1] < best[1] ? row : best; }, rows[0]);
    var maximum = rows.reduce(function (best, row) { return Math.max(best, row[2]); }, 0);
    var media = card.querySelector('.card__media, .card__inner, .media') || card;
    var price = card.querySelector('.price');
    var target = card.querySelector('.beleaev-price-row') || card.querySelector('.card__information, .card-information, .card__content') || card;
    card.classList.add('beleaev-oct-card');
    if (price) price.style.display = 'none';
    var badge = document.createElement('span');
    badge.className = 'beleaev-oct-badge';
    badge.textContent = 'SAVE UP TO ' + maximum + '%';
    media.appendChild(badge);
    var visual = document.createElement('div');
    visual.className = 'beleaev-oct-card-price';
    visual.innerHTML = '<span class="beleaev-oct-was">From ' + money(lowest[0]) + '</span><span class="beleaev-oct-now">' + money(lowest[1]) + '</span>';
    target.appendChild(visual);
    if (target.classList.contains('beleaev-price-row')) {
      var quickAdd = target.querySelector(':scope > .quick-add');
      var nativePrice = target.querySelector(':scope > .price');
      if (quickAdd) target.insertBefore(visual, quickAdd);
      if (nativePrice) nativePrice.style.setProperty('display', 'none', 'important');
      var liftedLabel = target.querySelector(':scope > .beleaev-from-label-mobile');
      target.style.setProperty('display', 'flex', 'important');
      ['grid-template-columns', 'grid-template-areas', 'column-gap', 'row-gap'].forEach(function (property) { target.style.removeProperty(property); });
      target.style.setProperty('align-items', 'center', 'important');
      target.style.setProperty('justify-content', 'space-between', 'important');
      target.style.setProperty('gap', '0.6rem', 'important');
      if (liftedLabel) liftedLabel.style.setProperty('display', 'none', 'important');
      visual.style.setProperty('flex', '1 1 auto', 'important');
      visual.style.setProperty('min-width', '0', 'important');
      if (quickAdd) {
        ['grid-area', 'align-self', 'position', 'inset'].forEach(function (property) { quickAdd.style.removeProperty(property); });
        quickAdd.style.setProperty('position', 'relative', 'important');
        quickAdd.style.setProperty('inset', 'auto', 'important');
        quickAdd.style.setProperty('flex', '0 0 auto', 'important');
      }
    }
  }
  function decorateCards(root) {
    (root || document).querySelectorAll('.card-wrapper.product-card-wrapper').forEach(decorate);
  }
  function installStyle() {
    if (document.getElementById('beleaev-october-card-style')) return;
    var style = document.createElement('style');
    style.id = 'beleaev-october-card-style';
    style.textContent = '.beleaev-oct-card{position:relative}.beleaev-oct-badge{position:absolute;z-index:4;left:8px;bottom:8px;padding:5px 8px;border-radius:999px;background:#d5ad4d;color:#050505;font:700 10px/1 var(--font-body-family);letter-spacing:.04em}.beleaev-oct-card-price{display:flex;align-items:baseline;gap:7px;white-space:nowrap;margin-top:7px;font-family:var(--font-body-family)}.beleaev-oct-was{color:rgba(var(--color-foreground),.62);text-decoration:line-through}.beleaev-oct-now{color:#d5ad4d;font-weight:700}@media(max-width:749px){.beleaev-oct-badge{font-size:8px;padding:4px 6px}.beleaev-oct-card-price{gap:5px;font-size:.92rem}}.beleaev-oct-badge{display:none}';
    document.head.appendChild(style);
  }
  function boot() { installStyle(); decorateCards(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  new MutationObserver(function (records) { records.forEach(function (record) { record.addedNodes.forEach(function (node) { if (node.nodeType === 1) decorateCards(node); }); }); }).observe(document.documentElement, { childList: true, subtree: true });
}());
